<button
  type="button"
  class="block w-full min-h-[44px] rounded-xl px-1.5 text-left hover:bg-primary/10 focus-visible:outline-primary"
  [cdkCopyToClipboard]="text"
  (cdkCopyToClipboardCopied)="copied($event)"
>
  {{ "DISCUSSION.COPY" | translate }}
</button>
